import Structor from "../util/structor"
import DateAnnotationCourseCustomSingleAttributes from "./date-annotation-course-custom-single"
import DateAnnotationCourseDefaultAttributes from "./date-annotation-course-default-attributes"
import DateAnnotationGroupAttributes from "./date-annotation-group-attributes"
import DateAnnotationPlanbookCustomRangeAttributes from "./date-annotation-planbook-custom-range-attributes"
import DateAnnotationPlanbookCustomSingleAttributes from "./date-annotation-planbook-custom-single"

export default class DateAnnotation extends Structor {
  defineStruct() {
    this.field("id")
    this.field("type")
    this.field("attributes", (model) => {
      if (model.type === "date-annotation-planbook-custom-single")
        return new DateAnnotationPlanbookCustomSingleAttributes(model.attributes)
      if (model.type === "date-annotation-planbook-custom-range")
        return new DateAnnotationPlanbookCustomRangeAttributes(model.attributes)
      if (model.type === "date-annotation-course-custom-single")
        return new DateAnnotationCourseCustomSingleAttributes(model.attributes)
      if (model.type === "date-annotation-course-default")
        return new DateAnnotationCourseDefaultAttributes(model.attributes)
      if (model.type === "date-annotation-group")
        return new DateAnnotationGroupAttributes(model.attributes)
    })
  }
}
